import { browserTypes } from 'browser-type-detector';

export const unsupportedBrowsersList = [
	{
		name: browserTypes.ie.name,
		specificUnsupportedVersions: [],
		minimalSupportedVersion: browserTypes.ie.relevantVersions['11'].name,
		maximalSupportedVersion: null,
	},
];